<template>
  <v-form ref="advSearch">
    <v-row
      style="max-width: 1185px"
      class="mx-auto"
    >
      <v-col cols="12">
        <h2 class="title primary--text text-center">
          Busca avançada
        </h2>
      </v-col>
      <v-col>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-row
              dense
              class="align-center"
            >
              <v-col
                cols="12"
                md="3"
                class="text-right pr-4"
              >
                Acervo
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  dense
                  :value="filter.idTipoPublicacao"
                  :items="collections"
                  item-text="tipoPublicacao"
                  item-value="idTipopublicacao"
                  @input="onPatchFilter({idTipoPublicacao: $event})"
                  placeholder="Selecione o acervo"
                  hide-details
                  outlined
                  rounded
                ></v-select>
              </v-col>
              <v-col
                v-if="hasPermission"
                cols="12"
                md="3"
                class="text-center"
              >
                <v-checkbox
                  dense
                  hide-details
                  class="mt-0"
                  label="Privado"
                  value="privado"
                  @change="onPatchFilter({nivel: $event})"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-row
              dense
              class="align-center"
            >
              <v-col
                cols="12"
                md="3"
                class="text-right pr-4"
              >
                Área
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  dense
                  :value="filter.idSegmento"
                  :items="segmentos"
                  item-text="segmento"
                  item-value="id"
                  @input="onPatchFilter({idSegmento: $event})"
                  placeholder="Selecione o acervo"
                  hide-details
                  outlined
                  rounded
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-row dense>
              <v-col
                cols="12"
                md="3"
              >
                <v-select
                  dense
                  :value="filter.conditionals && filter.conditionals.first.select"
                  :items="fields"
                  @input="onPatchFilter({
                                  conditionals: {
                                    ...filter.conditionals,
                                    first: {
                                      ...filter.conditionals.first,
                                      select: $event,
                                    }
                                  }
                                })"
                  placeholder="Escolha o campo"
                  hide-details
                  outlined
                  rounded
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  dense
                  placeholder="Digite aqui"
                  single-line
                  outlined
                  rounded
                  :value="filter.conditionals && filter.conditionals.first.input"
                  @input="onPatchFilter({
                                  conditionals: {
                                    ...filter.conditionals,
                                    first: {
                                      ...filter.conditionals.first,
                                      input: $event,
                                    }
                                  }
                                })"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="3"
                class="text-center"
              >
                <v-select
                  dense
                  :value="filter.conditionals && filter.conditionals.first.conditional"
                  :items="conditionalFields"
                  @input="onPatchFilter({
                                  conditionals: {
                                    ...filter.conditionals,
                                    first: {
                                      ...filter.conditionals.first,
                                      conditional: $event,
                                    }
                                  }
                                })"
                  placeholder="Condição"
                  hide-details
                  outlined
                  rounded
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-row dense>
              <v-col
                cols="12"
                md="3"
              >
                <v-select
                  dense
                  :value="filter.conditionals && filter.conditionals.second.select"
                  :items="fields"
                  @input="onPatchFilter({
                                  conditionals: {
                                    ...filter.conditionals,
                                    second: {
                                      ...filter.conditionals.second,
                                      select: $event,
                                    }
                                  }
                                })"
                  placeholder="Escolha o campo"
                  hide-details
                  outlined
                  rounded
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  dense
                  placeholder="Digite aqui"
                  single-line
                  outlined
                  rounded
                  :value="filter.conditionals.second.input"
                  @input="onPatchFilter({
                                  conditionals: {
                                    ...filter.conditionals,
                                    second: {
                                      ...filter.conditionals.second,
                                      input: $event,
                                    }
                                  }
                                })"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="3"
                class="text-center"
              >
                <v-select
                  dense
                  :value="filter.conditionals && filter.conditionals.second.conditional"
                  :items="conditionalFields"
                  @input="onPatchFilter({
                                  conditionals: {
                                    ...filter.conditionals,
                                    second: {
                                      ...filter.conditionals.second,
                                      conditional: $event,
                                    }
                                  }
                                })"
                  placeholder="Condição"
                  hide-details
                  outlined
                  rounded
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-row dense>
              <v-col
                cols="12"
                md="3"
              >
                <v-select
                  dense
                  :value="filter.conditionals && filter.conditionals.third.select"
                  :items="fields"
                  @input="onPatchFilter({
                                  conditionals: {
                                    ...filter.conditionals,
                                    third: {
                                      ...filter.conditionals.third,
                                      select: $event,
                                    }
                                  }
                                })"
                  placeholder="Escolha o campo"
                  hide-details
                  outlined
                  rounded
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  dense
                  placeholder="Digite aqui"
                  single-line
                  outlined
                  rounded
                  :value="filter.conditionals && filter.conditionals.third.input"
                  @input="onPatchFilter({
                                  conditionals: {
                                    ...filter.conditionals,
                                    third: {
                                      ...filter.conditionals.third,
                                      input: $event,
                                    }
                                  }
                                })"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="3"
                class="text-center"
              >
                <v-select
                  dense
                  :value="filter.conditionals && filter.conditionals.third.conditional"
                  :items="conditionalFields"
                  @input="onPatchFilter({
                                  conditionals: {
                                    ...filter.conditionals,
                                    third: {
                                      ...filter.conditionals.third,
                                      conditional: $event,
                                    }
                                  }
                                })"
                  placeholder="Condição"
                  hide-details
                  outlined
                  rounded
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-row dense>
              <v-col
                cols="12"
                md="3"
              >
                <v-select
                  dense
                  :value="filter.conditionals && filter.conditionals.fourth.select"
                  :items="fields"
                  @input="onPatchFilter({
                                  conditionals: {
                                    ...filter.conditionals,
                                    fourth: {
                                      ...filter.conditionals.fourth,
                                      select: $event,
                                    }
                                  }
                                })"
                  placeholder="Escolha o campo"
                  hide-details
                  outlined
                  rounded
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  dense
                  placeholder="Digite aqui"
                  single-line
                  outlined
                  rounded
                  :value="filter.conditionals && filter.conditionals.fourth.input"
                  @input="onPatchFilter({
                                  conditionals: {
                                    ...filter.conditionals,
                                    fourth: {
                                      ...filter.conditionals.fourth,
                                      input: $event,
                                    }
                                  }
                                })"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="3"
                class="text-center"
              >
                <v-select
                  dense
                  :value="filter.conditionals && filter.conditionals.fourth.conditional"
                  :items="conditionalFields"
                  @input="onPatchFilter({
                                  conditionals: {
                                    ...filter.conditionals,
                                    fourth: {
                                      ...filter.conditionals.fourth,
                                      conditional: $event,
                                    }
                                  }
                                })"
                  placeholder="Condição"
                  hide-details
                  outlined
                  rounded
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-row dense>
              <v-col
                cols="12"
                md="3"
              >
                <v-select
                  dense
                  :value="filter.conditionals.fifth.select"
                  :items="fields"
                  @input="onPatchFilter({
                                  conditionals: {
                                    ...filter.conditionals,
                                    fifth: {
                                      ...filter.conditionals.fifth,
                                      select: $event,
                                    }
                                  }
                                })"
                  placeholder="Escolha o campo"
                  hide-details
                  outlined
                  rounded
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  dense
                  placeholder="Digite aqui"
                  single-line
                  outlined
                  rounded
                  :value="filter.conditionals && filter.conditionals.fifth.input"
                  @input="onPatchFilter({
                                  conditionals: {
                                    ...filter.conditionals,
                                    fifth: {
                                      ...filter.conditionals.fifth,
                                      input: $event,
                                    }
                                  }
                                })"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="3"
                class="text-center"
              >
                <v-select
                  dense
                  :value="filter.conditionals && filter.conditionals.fifth.conditional"
                  :items="conditionalFields"
                  @input="onPatchFilter({
                                  conditionals: {
                                    ...filter.conditionals,
                                    fifth: {
                                      ...filter.conditionals.fifth,
                                      conditional: $event,
                                    }
                                  }
                                })"
                  placeholder="Condição"
                  hide-details
                  outlined
                  rounded
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-row
              dense
              class="align-center"
            >
              <v-col
                cols="12"
                md="3"
                class="text-right pr-4"
              >
                Suporte
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-autocomplete
                  dense
                  :value="filter.suporte && filter.suporte.idSuporte"
                  :items="suportes"
                  @input="onPatchFilter({
                                  suporte: {
                                    ...filter.suporte,
                                    idSuporte: $event,
                                  }
                                })"
                  placeholder="Suporte"
                  item-text="descricao"
                  item-value="id"
                  hide-details
                  outlined
                  rounded
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="3"
                class="text-center"
              >
                <v-select
                  dense
                  :value="filter.suporte && filter.suporte.suporteConditional"
                  :items="conditionalFields"
                  @input="onPatchFilter({
                                  suporte: {
                                    ...filter.suporte,
                                    suporteConditional: $event,
                                  }
                                })"
                  placeholder="Condição"
                  hide-details
                  outlined
                  rounded
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-row
              dense
              class="align-center"
            >
              <v-col
                cols="12"
                md="3"
                class="text-right pr-4"
              >
                Idioma
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  dense
                  :value="filter.idioma && filter.idioma.idIdiomaPub"
                  :items="idiomas"
                  item-text="idioma"
                  item-value="id"
                  @input="onPatchFilter({
                                  idioma: {
                                    ...filter.idioma,
                                    idIdiomaPub: $event,
                                  }
                                })"
                  placeholder="Idioma"
                  hide-details
                  outlined
                  rounded
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                md="3"
                class="text-center"
              >
                <v-select
                  dense
                  :value="filter.idioma && filter.idioma.idiomaConditional"
                  :items="conditionalFields"
                  @input="onPatchFilter({
                                  idioma: {
                                    ...filter.idioma,
                                    idiomaConditional: $event,
                                  }
                                })"
                  placeholder="Condição"
                  hide-details
                  outlined
                  rounded
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-row
              dense
              class="align-center"
            >
              <v-col
                cols="12"
                md="3"
                class="text-right pr-4"
              >
                Localização
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  dense
                  placeholder="Digite aqui"
                  single-line
                  outlined
                  rounded
                  :value="filter.localizacaoFisica"
                  @input="onPatchFilter({localizacaoFisica: $event})"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-row
              dense
              class="align-center"
            >
              <v-col
                cols="12"
                md="3"
                class="text-right pr-4"
              >
                Data inicial
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-mask="['##/##/####']"
                  label="Data inicial *"
                  placeholder="DD/MM/AAAA"
                  :rules="[rules.date]"
                  single-line
                  type="tel"
                  outlined
                  rounded
                  dense
                  hide-details
                  :value="filter.initialDate"
                  @input="onPatchFilter({initialDate: $event})"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-row
              dense
              class="align-center"
            >
              <v-col
                cols="12"
                md="3"
                class="text-right pr-4"
              >
                Data final
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-mask="['##/##/####']"
                  label="Data final *"
                  placeholder="DD/MM/AAAA"
                  :rules="[rules.date]"
                  single-line
                  type="tel"
                  outlined
                  rounded
                  dense
                  hide-details
                  :value="filter.endDate"
                  @input="onPatchFilter({endDate: $event})"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="hasPermission">
          <v-col
            cols="12"
            md="6"
          >
            <v-row
              dense
              class="align-center"
            >
              <v-col
                cols="12"
                md="3"
                class="text-right pr-4"
              >
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="pt-0"
              >
                <v-checkbox
                  dense
                  hide-details
                  class="pt-0 mt-0"
                  label="Direito Autoral"
                  @change="onPatchFilter({autorizacaoFotografo: $event})"
                />
                </v-col>
                <v-col
                cols="12"
                md="4"
                class="pt-0"
              >
                <v-checkbox
                  dense
                  hide-details
                  class="mt-0"
                  label="Direito de Imagem"
                  @change="onPatchFilter({autorizacaoFotografado: $event})"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row
          justify="end"
          align="center"
          class="mx-0 mt-5"
        >
          <v-btn
            text
            rounded
            @click="onSearchTypeChange('simple')"
            class="mr-10"
          >
            CANCELAR
          </v-btn>
          <v-btn
            color="accent"
            rounded
            depressed
            @click="onAdvancedSearch($refs.advSearch)"
          >
            BUSCAR
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import formRules from '@/mixins/form-rules';

export default {
  mixins: [formRules],
  props: {
    onPatchFilter: {
      type: Function,
      default: () => false,
    },
    filter: {
      type: Object,
      default: () => {},
    },
    onSearchTypeChange: {
      type: Function,
      default: () => {},
    },
    onAdvancedSearch: {
      type: Function,
      default: () => {},
    },
    suportes: {
      type: Array,
      default: () => [],
    },
    idiomas: {
      type: Array,
      default: () => [],
    },
    segmentos: {
      type: Array,
      default: () => [],
    },
    collections: {
      type: Array,
      default: () => [],
    },
    hasPermission: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuInitial: false,
      menuEnd: false,
      fields: [
        {
          text: 'Título',
          value: 'nome',
        },
        {
          text: 'Tema',
          value: 'sinopse',
        },
        {
          text: 'Palavra-chave',
          value: 'palavrachave',
        },
        {
          text: 'Descrição',
          value: 'conteudo',
        },
        {
          text: 'Autor',
          value: 'autor',
        },
      ],
      conditionalFields: [
        {
          text: 'E',
          value: 'AND',
        },
        {
          text: 'Ou',
          value: 'OR',
        },
        {
          text: 'E não',
          value: 'AND NOT',
        },
      ],
    };
  },
};
</script>
<style scoped>
.v-text-field--rounded > .v-input__control > .v-input__slot {
  padding: 0 12px !important;
}
.v-text-field--rounded ::v-deep .v-input__icon {
  width: 10px;
  min-width: 10px;
}
.v-text-field--rounded ::v-deep .v-icon.v-icon {
  font-size: 14px !important;
}
</style>
